export const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

/** Today as YYYY-MM-DD string. */
export const todayStr = () => new Date().toISOString().split("T")[0];

/** Generate a short unique ID (not cryptographic, fine for local record keys). */
export const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
